var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" Merci pour votre inscription et rendez-vous le mercredi 3 février 2021! ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }